import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    replaceHistoryState,
    forceRerenderContent,
} from "client/utils"
import {
    StoreType,
    setUrlOrigin,
    renderContent,
} from "client/store"
import {
    RouteItem,
    projectsRoute,
} from "client/parts/routes"
import {
    MenuColumn,
    MenuColumnHeader,
    MenuContent,
} from "client/parts/layout"
import { Link } from "client/components"
import {
    MenuItem,
    MenuSubItemWrapper,
    MenuSubItem,
    MenuItemTitle,
    MenuItemArrow,
} from "./styled"


interface ExpandedRoutes { [path: string]: boolean }

interface MenuProps {
    routes: RouteItem[]
}

const Menu = ({
    routes = null,
}: MenuProps) => {
    const [activeItem, setActiveItem] = useState<string>(null)
    const [activeSubItem, setActiveSubItem] = useState<string>(null)
    const [expandedRoutes, setExpandedRoutes] = useState<ExpandedRoutes>({})

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    useEffect(() => {
        parseRoute()
        dispatch(renderContent(true))
    }, [])

    const parseRoute = () => {
        let { pathname } = window.location
        if (pathname === "/") {
            pathname = projectsRoute
            replaceHistoryState(projectsRoute)
        }
        dispatch(setUrlOrigin(pathname))

        const expanded: ExpandedRoutes = {}

        routes.forEach((route) => {
            if (pathname.indexOf(route.path) === 0) {
                if (route.routes) {
                    expanded[route.path] = true
                    setExpandedRoutes(expanded)

                    route.routes.forEach((subRoute) => {
                        if (pathname.indexOf(subRoute.path) === 0) {
                            setActiveSubItem(subRoute.path)
                        }
                    })
                } else {
                    setActiveItem(route.path)
                }
            }
        })
    }

    const onClickRoute = (route: RouteItem) => {
        if (route.routes) {
            const expanded: ExpandedRoutes = { ...expandedRoutes }
            if (expanded[route.path]) expanded[route.path] = false
            else expanded[route.path] = true
            setExpandedRoutes(expanded)
        } else {
            setActiveItem(route.path)
            setActiveSubItem(null)

            forceRerenderContent(route.path, dispatch)
        }
    }

    const onClickSubRoute = (route: RouteItem) => {
        setActiveItem(null)
        setActiveSubItem(route.path)

        forceRerenderContent(route.path, dispatch)
    }

    return (
        <MenuColumn>
            <MenuColumnHeader>
                {lang.businessMaster}
            </MenuColumnHeader>
            <MenuContent>
                {
                    routes.map((route) => {
                        if (!route.access) return ""

                        const isExpanded = !!expandedRoutes[route.path]
                        return ([
                            <MenuItem
                                key={`route_${route.path}`}
                                isActive={activeItem === route.path}
                            >
                                <Link
                                    href={route.path}
                                    onClick={() => onClickRoute(route)}
                                >
                                    <MenuItemTitle>{route.title}</MenuItemTitle>
                                    {
                                        route.routes
                                        && <MenuItemArrow isExpanded={isExpanded} />
                                    }
                                </Link>
                            </MenuItem>,

                            route.routes
                            && (
                                <MenuSubItemWrapper
                                    key={`subRoutes_${route.path}`}
                                    isExpanded={isExpanded}
                                    childrenLength={route.routes.filter((subRoute) => subRoute.access).length}
                                >
                                    {
                                        route.routes.map((subRoute) => {
                                            if (!subRoute.access) return ""
                                            return (
                                                <MenuSubItem
                                                    key={subRoute.path}
                                                    isActive={activeSubItem === subRoute.path}
                                                >
                                                    <Link
                                                        href={subRoute.path}
                                                        onClick={() => onClickSubRoute(subRoute)}
                                                    >
                                                        <MenuItemTitle>{subRoute.title}</MenuItemTitle>
                                                    </Link>
                                                </MenuSubItem>
                                            )
                                        })
                                    }
                                </MenuSubItemWrapper>
                            ),
                        ])
                    })
                }
            </MenuContent>
        </MenuColumn>
    )
}
export default Menu
